









































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import NewsModel from '@views/a-model/news-model';
import DefaultModel from '@views/a-model/default-model';
import EnumNewsType from '../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';
import iMobileDeviceUser from '../a-model/interfaces/iMobileDeviceUser';
import { EnumRoleType } from '../a-model/enum/EnumRoleType';
import iKpi from '../a-model/interfaces/iKpi';
import EnumKpiValueType from '../../dataSource/api/RunPay/Admin/IServices/Enums/EnumKpiValueType';
import KpiTranslateItemResponse from '../../dataSource/api/RunPay/Admin/IServices/Models/KPIs/KpiTranslateItemResponse';
// import EnumKpiValueType from "../../DataSource/api/RunPay/Admin/IServices/Enums/EnumKpiValueType";
// import EnumKpiValueType from "../../DataSource/api/RunPay/Admin/IServices/Enums/EnumKpiValueType";

@Component({
  name: 'kpi',
  components: {},
})
export default class KpiComponent extends Vue {
  currentRolleId: String = null;
  currentUserId: String = null;
  userId: String = null;
  pageSize = 20;
  currentPage = 1;
  totalItems = 5;

  modalWindowTitle = '';
  modalWindowShow = false;
  modalWindowShowDesc = false;
  terminaleCode = '';

  userRoles: ListViewItem<DefaultModel>[] = [];

  search = '';
  Items: iKpi[] = [];
  innerItems: iKpi[] = [];
  target = '';
  targets: ListViewItem<DefaultModel>[] = [];

  fromDate: Date = new Date();
  toDate: Date = new Date();
  quantity = '1';
  reward = '0';
  currentId = 0;

  desk: KpiTranslateItemResponse[] = [];
  created() {
    document.title = this.$route.meta.title;
    this.getTargets();
    this.getItems({ Take: this.pageSize, Skip: 0 });
    this.getDesk();
  }

  getDesk() {
    this.desk = [];
    this.desk.push({ LangCode: 'ru', Text: '' });
    this.desk.push({ LangCode: 'en', Text: '' });
    this.desk.push({ LangCode: 'fr', Text: '' });
  }
  onModalWindowAddKpi() {
    this.getDesk();
    this.modalWindowShow = true;
  }
  onModalWindowDesc(currentId: number) {
    this.desk = this.innerItems.find((item) => item.id == currentId).translates;
    if (!this.desk.find((item) => item.LangCode == 'ru')) this.desk.push({ LangCode: 'ru', Text: '' });
    if (!this.desk.find((item) => item.LangCode == 'en')) this.desk.push({ LangCode: 'en', Text: '' });
    if (!this.desk.find((item) => item.LangCode == 'fr')) this.desk.push({ LangCode: 'fr', Text: '' });
    this.currentId = currentId;
    this.modalWindowShowDesc = true;
  }

  closeModalWindow() {
    this.reward = '0';
    this.quantity = '1';
    this.modalWindowShow = false;
  }
  closeModalWindowDesc() {
    this.modalWindowShowDesc = false;
  }

  onSearch() {
    this.getItems({ Take: this.pageSize, Skip: this.currentPage });
  }

  onChangeDate(arrayDate0: Date, arrayDate1: Date) {
    this.fromDate = arrayDate0;
    if (arrayDate1 != null) {
      this.toDate = arrayDate1;
    }
  }

  onEditDesc(idKpi: number) {
    this.$api.KpiService.ChangeKpiEvent.once((response) => {
      this.getItems({ Take: this.pageSize, Skip: this.currentPage });
      this.modalWindowShowDesc = false;
      if (!response.IsSuccess) {
        return;
      }
    });
    if (!this.isValidDsk()) {
      return;
    }

    this.$api.KpiService.ChangeKpi({
      Id: idKpi,
      Translations: this.desk,
    });
  }

  onAddKpi() {
    //проверить заполнение формы
    if (!this.isValid()) {
      return;
    }
    this.$api.KpiService.AddKpiEvent.once((response) => {
      this.modalWindowShow = false;
      this.getItems({ Take: this.pageSize, Skip: this.currentPage });
      if (!response.IsSuccess) {
        return;
      }
    });
    this.$api.KpiService.AddKpi({
      DateStart: this.fromDate,
      DateEnd: this.toDate,
      Count: parseInt(this.quantity),
      Reward: parseInt(this.reward),
      Translations: this.desk,
      // GoalDescription:this.targets.filter(el=>el.Selected==true)[0].Value.name,

      Type: (this.targets.filter((el) => el.Selected == true)[0].Value as DefaultModel).id,
    });
  }

  onAddUser(kpiId: string) {
    this.$router.push(`kpi-user/${kpiId}`);
  }

  getTargets() {
    this.targets = [];
    this.targets.push(new ListViewItem(new DefaultModel(EnumKpiValueType.Count, this.$locale.getTranslate('Kpi_target_quantity')), true, false));
    this.targets.push(new ListViewItem(new DefaultModel(EnumKpiValueType.SumMoney, this.$locale.getTranslate('Kpi_target_sum')), false, false));
    this.targets.push(new ListViewItem(new DefaultModel(EnumKpiValueType.Percents, this.$locale.getTranslate('Kpi_target_terminals')), false, false));
  }
  getTarget(goal: EnumKpiValueType): string {
    switch (goal) {
      case EnumKpiValueType.Count:
        return this.$locale.getTranslate('Kpi_target_quantity');
      case EnumKpiValueType.SumMoney:
        return this.$locale.getTranslate('Kpi_target_sum');
      case EnumKpiValueType.Percents:
        return this.$locale.getTranslate('Kpi_target_terminals');
    }
  }

  getTranslates(item: KpiTranslateItemResponse[]) {
    // debugger;
    let rez = item.find((item) => item.LangCode == this.$locale.currentLang);
    if (rez == null) return '';
    return rez.Text;
  }

  getItems({ Skip, Take }: { Skip: number; Take: number }) {
    this.innerItems = [];

    this.$api.KpiService.GetPaginatedKpisListEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }
      this.totalItems = response.Value.Count;
      this.innerItems = response.Value.Items.map((item) => ({
        id: item.Id,
        fromDate: item.DateStart,
        toDate: item.DateEnd,
        valueType: item.ValueType,
        translates: item.Translates,
        // desc:(item.Translates.find(item=>item.LangCode==this.$locale.currentLang)||item.Translates[0]).Text,
        count: item.Value,
        reward: item.Reward,
      }));
    });
    this.$api.KpiService.GetPaginatedKpisList({ Skip: Skip, Take: Take });
  }

  isValid(): boolean {
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid();
  }
  isValidDsk(): boolean {
    return (this.$refs.validator1 as ControlValidatorGroupComponent).isValid();
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.getItems({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage,
    });
  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case 'id':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case 'target':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.target > b.target ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.target < b.target ? 1 : -1;
          });
          break;
        }
      case 'reward':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.reward > b.reward ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.reward < b.reward ? 1 : -1;
          });
          break;
        }
      case 'period':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.fromDate > b.fromDate ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.fromDate < b.fromDate ? 1 : -1;
          });
          break;
        }

      default:
        break;
    }
  }
  onChangeUser(userId: string) {
    this.$router.push({ path: `devices/${userId}` });
  }
  async onDeleteKpi(kpiId: number) {
    var res = await this.$dialog.confirm(this.$locale.getTranslate('Dialog_reallyDelete')).then((res: boolean) => {
      if (res) {
        this.$api.KpiService.DeleteKpiEvent.once((response) => {
          if (!response.IsSuccess) {
            return;
          }

          this.getItems({ Take: this.pageSize, Skip: this.currentPage });
        });
        this.$api.KpiService.DeleteKpi(kpiId);
      }
      if (res == false) {
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-kpi.vue